module.exports = __webpack_public_path__ + "static/soldout-7ddc5e01dbcbb36a4c8dc9a53016a754.png";